module.exports = __webpack_public_path__ + "static/img/14.d57c14d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/14.png
// module id = HSWN
// module chunks = 0